<template>
  <el-col :span="normalizedSpan">
    <el-form-item :prop="name" :label="label" :label-width="labelWidth" :rules="normalizedRules">
      <OSwitch v-model="model" :disabled="normalizedDisabled" @change="(attrs.onChange)"></OSwitch>
    </el-form-item>
  </el-col>
</template>

<script setup lang="ts">
import { ElCol, ElFormItem } from 'element-plus'
import type { FormSwitchProps } from './Switch'
import OSwitch from '../../Input/Switch/Switch.vue'
import { useFormItemDisabled, useFormItemModel, useFormItemRules, useFormItemSpan } from '../hooks'
import { useAttrs } from 'vue'

defineOptions({ name: 'OFormSwitch', inheritAttrs: false })
const attrs = useAttrs()

const { name, label, labelWidth } = defineProps<FormSwitchProps>()
const normalizedSpan = useFormItemSpan()
const normalizedRules = useFormItemRules()
const normalizedDisabled = useFormItemDisabled()
const model = useFormItemModel()
</script>
